import React from "react";
import { useSelector } from "react-redux";
import { Row } from "antd";

import NotSelected from "../NotSelected";
import RankingAnalytics from "./RankingAnalytics";
import WeeklyRanksChart from "./WeeklyRanksChart";
import WeeklyByRanksChart from "./WeeklyByRanksChart";

const RankingDashboard = () => {
  const domain = useSelector((state) => state.domains.currentDomain);

  return (
    <>
      {domain !== null ? (
        <>
          <Row>
            <RankingAnalytics />
            <WeeklyRanksChart />
          </Row>
          <br />
          <Row>
            <WeeklyByRanksChart />
          </Row>
        </>
      ) : (
        <NotSelected title="Please Select Domain." />
      )}
    </>
  );
};

export default RankingDashboard;
